import * as Sentry from '@sentry/browser'

// Reporting must never be the reason a checkout fails, so a broken or blocked
// Sentry client is swallowed rather than propagated to the caller.
export function captureError(error) {
  try {
    Sentry.captureException(error)
  } catch(e) {}
}
